import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const NewsletterForm = () => {
  const { language, t } = useLanguage();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success', 'error', null
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/newsletter`, {
        email,
        language
      });
      setStatus('success');
      setEmail('');
    } catch (err) {
      setStatus('error');
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(null), 5000);
    }
  };

  return (
    <div className="text-center" data-testid="newsletter-form">
      <h3 className="text-2xl md:text-3xl font-semibold mb-4">
        {t('newsletter.title')}
      </h3>
      <p className="text-white/70 mb-8 max-w-md mx-auto">
        {t('newsletter.description')}
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('newsletter.placeholder')}
          className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:border-[#2E5E99]"
          required
          data-testid="newsletter-email-input"
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-[#2E5E99] hover:bg-[#1E4F85] text-white"
          data-testid="newsletter-submit-btn"
        >
          {loading ? (
            <span className="animate-spin w-5 h-5 border-2 border-white/30 border-t-white rounded-full" />
          ) : (
            <>
              {t('newsletter.button')}
              <Send className="w-4 h-4 ml-2" />
            </>
          )}
        </Button>
      </form>

      {/* Status Messages */}
      {status && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className={`mt-4 flex items-center justify-center space-x-2 ${
            status === 'success' ? 'text-green-400' : 'text-red-400'
          }`}
        >
          {status === 'success' ? (
            <CheckCircle className="w-5 h-5" />
          ) : (
            <AlertCircle className="w-5 h-5" />
          )}
          <span>
            {status === 'success' ? t('newsletter.success') : t('newsletter.error')}
          </span>
        </motion.div>
      )}
    </div>
  );
};
